import type { ImpressumStrings } from "../../types";

export const impressum: ImpressumStrings = {
  title: "Impressum",
  sections: [
    {
      title: "Information pursuant to § 5 DDG",
      paragraphs: [
        { pre: true, nodes: ["0-AI UG (haftungsbeschränkt)\nNeckartalstraße 127\n70376 Stuttgart\nGermany"] },
      ],
    },
    {
      title: "Represented by",
      paragraphs: [
        { pre: true, nodes: ["Managing directors:\nPaul Willi Patrick Horn\nAnton Leo Rudolf Horn"] },
      ],
    },
    {
      title: "Contact",
      paragraphs: [{ nodes: ["Email: contact@cero-ai.com"] }],
    },
    {
      title: "Register entry",
      paragraphs: [
        { pre: true, nodes: ["Entry in the commercial register\nRegister court: Amtsgericht Stuttgart\nRegister number: In registration"] },
      ],
    },
    {
      title: "VAT ID",
      paragraphs: [
        { pre: true, nodes: ["VAT identification number pursuant to § 27a UStG:\nApplied for"] },
      ],
    },
    {
      title: "Responsible for content pursuant to § 18 (2) MStV",
      paragraphs: [
        { pre: true, nodes: ["Paul Willi Patrick Horn\nNeckartalstraße 127\n70376 Stuttgart"] },
      ],
    },
    {
      title: "Dispute resolution",
      paragraphs: [
        {
          nodes: [
            "The European Commission provides a platform for online dispute resolution (ODR): ",
            { link: "ec.europa.eu/consumers/odr", href: "https://ec.europa.eu/consumers/odr/" },
          ],
        },
        {
          nodes: [
            "We are neither willing nor obliged to participate in dispute resolution proceedings before a consumer arbitration board.",
          ],
        },
      ],
    },
  ],
};
